import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const proofpoint = defineConnector({
  identifier: "proofpoint",
  name: "Proofpoint TAP",
  tagLine: "Targeted attack protection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://tap-api-v2\\.proofpoint\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.servicePrincipal,
      password: app.secret.serviceSecret,
    }),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Proofpoint TAP dashboard, go to **Settings > Connected Applications** to create a service principal and secret for API access.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Service principal",
          required: true,
          target: { kind: "configuration", field: "servicePrincipal" },
          helperText: "The service principal (username) for TAP API access.",
        },
        {
          kind: "input",
          label: "Service secret",
          required: true,
          target: { kind: "secrets", field: "serviceSecret" },
          helperText: "The service secret (password) for TAP API access.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://tap-api-v2.proofpoint.com/v2/siem/all?sinceSeconds=3600&format=json",
  },
});
